import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionConfig, SessionHooks } from '@movilidad/app-core';
import { QueryClient } from '@tanstack/angular-query-experimental';

/** Sin login todavía (TEC-483): a dónde mandan los guards en cuanto las pantallas los usen. */
export const SESSION: SessionConfig = {
  routes: {
    signedOut: '/',
    home: () => '/tabs/viajes',
  },
};

/** Lo que Passenger hace al cerrar sesión. El push (FCM) se da de baja aquí cuando exista. */
@Injectable({ providedIn: 'root' })
export class PassengerSessionHooks implements SessionHooks {
  private readonly queryClient = inject(QueryClient);
  private readonly router = inject(Router);

  onLogout(): void {
    this.queryClient.clear();
  }

  async afterLogout(): Promise<void> {
    await this.router.navigateByUrl(SESSION.routes.signedOut);
  }
}
